var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMdiFaceSad(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mdi:face-sad"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2H22V22H2V2ZM12.0025 16C13.2525 16 14.3225 16.5 14.7725 17.23L16.1925 15.81C15.2925 14.72 13.7525 14 12.0025 14C10.2525 14 8.7125 14.72 7.8125 15.81L9.2325 17.23C9.6825 16.5 10.7525 16 12.0025 16ZM7 9.5C7 8.7 7.7 8 8.5 8C9.3 8 10 8.7 10 9.5C10 10.3 9.3 11 8.5 11C7.7 11 7 10.3 7 9.5ZM15.5 11C14.7 11 14 10.3 14 9.5C14 8.7 14.7 8 15.5 8C16.3 8 17 8.7 17 9.5C17 10.3 16.3 11 15.5 11Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMdiFaceSad);
export default __webpack_public_path__ + "static/media/mdi_face-sad.e8df8071cd082ae7a73f02406af10097.svg";
export { ForwardRef as ReactComponent };